import { r as registerInstance, h } from './index-d4808923.js';

const gravityIconIndividualCss = ":host{display:contents}";
const GravityIconEnvelopeStyle0 = gravityIconIndividualCss;

const GravityIconEnvelope = class {
    constructor(hostRef) {
        registerInstance(this, hostRef);
        this.color = 'dark';
        this.size = 'xx-small';
    }
    render() {
        return (h("internal-gravity-base-icon", { key: '58bc2d50d61503f511c0683f8b9489ab7ea8cf90', color: this.color, size: this.size }, h("svg", { key: '76f5a8a8a1dc90bf60231018149e4c511bfefd77', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, h("path", { key: '4539e3554a658ac24a715998876798bd38937d31', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M2 4.5v13a.5.5 0 0 0 .5.5h17a.5.5 0 0 0 .5-.5v-13a.5.5 0 0 0-.5-.5h-17a.5.5 0 0 0-.5.5Zm15.16 1-6.17 5-6.17-5h12.34ZM3.5 16.5V6.36l7.18 5.77a.52.52 0 0 0 .63 0l7.19-5.78V16.5h-15Z", fill: "currentColor" }))));
    }
};
GravityIconEnvelope.style = GravityIconEnvelopeStyle0;

export { GravityIconEnvelope as gravity_icon_envelope };

//# sourceMappingURL=gravity-icon-envelope.entry.js.map